import React from 'react';
import '../../styles/WebPreloader.css';

const WebPreloader = () => {
  return (
    <div className="web-preloader">
      <div className="web-preloader__overlay">
        <div className="web-preloader__spinner">
          <div className="web-preloader__spinner-inner"></div>
        </div>
        <div className="web-preloader__text">Loading...</div>
      </div>
    </div>
  );
};

export default WebPreloader;
